import * as React from "react";

import DownloadReports from "./action-buttons/downloadReports";
import NewPost from "./action-buttons/newPost";
import PostListing from "./post-listing/postListing";

import BasePage from "pages/common/basePage";
import Header from "pages/common/header";
import MainContent from "pages/common/mainContent";
import { TAB_IDS } from "../models";
import { getTopicFilters } from "modules/topics/utils/topicAttributeFetcher";

class PostManagementPage extends React.Component<ComponentProps, ComponentState> {
    constructor(props) {
        super(props);

        this.state = {
            selectedTab: TAB_IDS.DRAFTS
        };
    }

    public render() {
        return (
            <BasePage fullWidth>
                <Header
                    title={"Manage Posts"}
                    rightComponent={
                        <React.Fragment>
                            {
                                !this.props.isContributor &&
                                // only support reports downloads for published posts because of accompanying post analytics data and stats
                                this.state.selectedTab === TAB_IDS.PUBLISHED && <DownloadReports />
                            }
                            <NewPost />
                        </React.Fragment>
                    }
                />

                <MainContent>
                    <div className="authoring-page">
                        <PostListing
                            selectedTab={this.state.selectedTab}
                            onSelectTab={this.onSelectTab}
                            topicFilters={getTopicFilters()}
                        />
                    </div>
                </MainContent>
            </BasePage>
        );
    }

    private onSelectTab = (tabIndex: number) => {
        this.setState({ ...this.state, selectedTab: tabIndex });
    };

}

interface ComponentProps {
    isContributor: boolean;
}

interface ComponentState {
    selectedTab: TAB_IDS;
}

export default PostManagementPage;